// Polyfills
import 'es6-promise/auto'
import 'babel-polyfill'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/ColorThemePlugin'
import store from '../store/index'
import router from '../router/index'
import VuesticPlugin from '../components/vuestic-plugin'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate'
import mixpanel from 'mixpanel-browser'

import '../metrics'

// vue-fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSun, faMoon, faCloud, faCloudSun, faCloudMoon, faCloudRain,
  faCloudShowersHeavy, faWind, faQuestion, faAngleDoubleRight,
  faArrowAltCircleRight,
  faArrowCircleRight,
  faExternalLinkAlt,
  faShare,
  faShareSquare,
  faTrashAlt,
  faBan,
} from '@fortawesome/free-solid-svg-icons' // fortawesome only has solid icons for free (not regular)
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faSun, faMoon, faCloud, faCloudSun, faCloudMoon, faCloudRain,
  faCloudShowersHeavy, faWind, faQuestion, faAngleDoubleRight,
  faArrowAltCircleRight,
  faArrowCircleRight,
  faExternalLinkAlt,
  faShare,
  faShareSquare,
  faTrashAlt,
  faBan,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
// Vue.use(library)
// Vue.use(faUserSecret)
// Vue.use(FontAwesomeIcon)

// end vue-fontawesome

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate, { fieldsBagName: 'formFields' })

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)
Vue.use(require('vue-cookie'))

Vue.use(ColorThemePlugin,
  {
    // Add or change theme colors here
    themes: {
      primary: '#0817bb', //
      blurple: '#0089DA', // not used??
      secondary: '#cdcdd0',
      background2: '#f6f6f6',
    },
  })

// Mixpanel
mixpanel.init('4aa29153fdfc5e1489dc09ac83940288')
Vue.prototype.$mixpanel = mixpanel

router.beforeEach((to, from, next) => {
  store.commit('setLoading', true)
  console.log('ROUTER.BEFORE EACH to=', to)
  if (to.path === '/auth/login' || to.path === '/auth/recover-password' || to.path.startsWith('/auth/new-password/')) {
    console.log('  NEXT')
    next()
    return
  }
  const sessKey = Vue.cookie.get('qsession')
  if (sessKey) {
    next()
    return
  }
  Vue.cookie.set('referLocation', to.path, Infinity, '/') // so we can go there after login
  console.log('  NEXT LOGIN')
  next('/auth/login')
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
})
